<div class="w-[31.25rem] flex flex-col justify-between" [class]="direction" [ngClass]="{'h-[17rem]' : isDesktop}">
  <div >
    <!--
      a11y: header row reordered so the close button is FIRST in DOM and
      marked with cdkFocusInitial (via [focusInitial]) so the CDK focus trap
      lands focus on it as the popup opens. The mobile (bottom-sheet) variant
      previously had NO close button at the top — the audit requires every
      popup to have one and to receive initial focus, so we now render it for
      both desktop and mobile. Tailwind `order-*` keeps the heading visually
      first while the close button stays in the trailing slot.
    -->
    <div class="flex justify-between mb-4">
      <mot-button matType="icon" icon="close"
        [ariaLabel]="closeText"
        class="!bg-transparent flex justify-end order-2" iconClass="!text-2xl"
        [focusInitial]="true"
        (onClick)="closeCard()" />
      <!-- a11y: popup heading is h2 (page-level h1 is the nav-bar logo). -->
      <h2 class="text-base px-2 order-1">{{timesLegendText}}</h2>
    </div>
    <!--
      a11y: legend entries exposed as a native list. The icon's color encodes
      the state (on time / planned / late); role="img" + aria-label mirrors
      that state textually so the icon is not just a decorative colored shape
      for SR users.
    -->
    <ul
      class="flex flex-col gap-8 px-2 list-none m-0 p-0"
      role="list"
      [attr.aria-label]="timesLegendText">
      @for (time of times; track time) {
        <li class="flex gap-2 items-start" role="listitem">
          <ng-icon
            name="rss-feed"
            class="text-base"
            [style.color]="time.color"
            role="img"
            [attr.aria-label]="time.text" />
          <span class="text-sm font-normal" aria-hidden="true">{{time.text}}</span>
        </li>
      }
    </ul>
  </div>
  @if (isDesktop) {
    <div class="!flex justify-end mb-3 px-2">
      <mot-button [text]="closeText"
        buttonClass="!bg-primary !w-4 !text-white !px-2 !py-3 !rounded-lg !align-middle mt-0.5"
        (onClick)="closeCard()"/>
      </div>
    }
  </div>